const TwitterIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="21" viewBox="0 0 25 21" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.99233 11.044L2.5 2H8.43445L13.0594 7.58984L18.0004 2.02517H21.2688L14.6397 9.49981L22.5 19H16.5833L11.5754 12.9549L6.22896 18.9832H2.94287L9.99233 11.044ZM17.4457 17.3243L6.13881 3.6757H7.57138L18.864 17.3243H17.4457Z" fill="#9297A8" />
        </svg>
    );
}
export default TwitterIcon;